import script from "./CmsSections.vue?vue&type=script&setup=true&lang=js"
export * from "./CmsSections.vue?vue&type=script&setup=true&lang=js"

import "./CmsSections.vue?vue&type=style&index=0&id=97922b4c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\banjara_matrimonial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97922b4c"]])

export default __exports__